import { createAction, props } from "@ngrx/store";
import {
  ConfirmedInstruction,
  Instruction,
  InstructionType,
  OpenInstruction,
} from "src/app/models/instruction/instruction";
import { InstructionConfirmation } from "src/app/models/instruction/instruction-confirmation";

export const loadInstructions = createAction(
  "[Instruction] load",
  props<{
    instructionType: InstructionType | "All";
  }>(),
);

export const loadedInstructions = createAction(
  "[Instruction] loaded",
  props<{
    confirmed: ConfirmedInstruction[];
    open: OpenInstruction[];
  }>(),
);
